export default __webpack_public_path__ + "static/media/nuode.32c18e20.png";